import { IModalConfig } from '../../../../../shared/modules/bs-modal/interfaces/modal-config.interface';
import { SuccessPopupComponent } from './success-popup.component';

export const SuccessModal: IModalConfig = {
    content: SuccessPopupComponent,
    options: {
        class: 'success-modal',
        initialState: {
            transactions: [],
            successCount: 0,
            total: 0,
            subTitle:
                'תמיד תוכלו להעביר את הוראות הקבע ישירות דרך בית העסק אם יש לך צורך, רשמנו את הטלפון שאנחנו מכירים',
            subTitleMobile: 'תמיד תוכלו להעביר את הוראות הקבע ישירות דרך בית העסק'
        } as Object,
        backdrop: 'static'
    },
    type: 'SuccessModal'
};
